import React, { useEffect, useRef, useState } from 'react';
import { ProductCardHome } from '../common/ProductCardHome';
import { getProducts } from '../../utils/api';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../store/languageContext';
import Header from '../common/Header';
import translate from '../../utils/translation';
import { motion } from 'framer-motion';
const LatestProducts = () => {
    const [products, setProducts] = useState([]);
    const sectionRef = useRef(null);
    const { language, setNavColor } = useLanguage();
    useEffect(() => {
        getProducts({ limit: 5 }).then(res => setProducts(res.data));
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setNavColor('white');
                }
            },
            {
                threshold: 0.1,
                rootMargin: '-50px 0px -20% 0px',
            }
        );

        const currentRef = sectionRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [setNavColor]);

    return (
        <section id='latest' ref={sectionRef} className="landing-section flex flex-col bg-[#111]">
            <div className="container mx-auto">
                <Header text={translate[language]['latestHeader']} theme="white" />
                <div className="flex text-white">
                    <div className='w-1/3' />
                    <div className="md:w-2/3 flex flex-col justify-between items-center">
                        <div className='w-1/2'>
                            <motion.h2
                                initial={{ y: 100, opacity: 0 }}
                                whileInView={{ y: 0, opacity: 1 }}
                                transition={{ duration: 0.5, delay: 0.2, ease: 'easeOut' }}
                                viewport={{ once: true }}
                                className='text-[60px] leading-[60px] font-semibold mb-4'>
                                {translate[language]['latestTitle1']}
                            </motion.h2>
                            <motion.p
                                initial={{ y: 50, opacity: 0 }}
                                whileInView={{ y: 0, opacity: 1 }}
                                transition={{ duration: 0.5, delay: 0.4, ease: 'easeOut' }}
                                viewport={{ once: true }}
                                className='opacity-[0.5]'>
                                {translate[language]['latestTitle2']}
                            </motion.p>
                        </div>
                    </div>
                </div>
                <div className="grid md:grid-cols-5 gap-4 mt-[50px]">
                    {products?.map((product, index) => (<motion.div
                        initial={{ y: 100, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.5, delay: (index + 1) * 0.2, ease: 'easeOut' }}
                        viewport={{ once: true }}
                        key={index}
                    >
                        <ProductCardHome key={product.id} product={product} />
                    </motion.div>)
                    )}
                </div>
                <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, delay: 1, ease: 'easeOut' }}
                    viewport={{ once: true }}
                    className={`${language === 'ar' ? 'text-left' : 'text-right'} mt-8`}>
                    <Link to="/products" className="text-white px-6 py-2 slef-end hover:underline">{translate[language]['viewAll']}</Link>
                </motion.div>
            </div>
        </section>
    );
};

export { LatestProducts };